<template>
  <div>
      <ul class="InformationInquiry">
          <div v-for="(item,index) in typeList" :key="item.id" :style="{width:(100/typeList.length)+'%'}" class="InformationInquiryItem" @click="eventBus(item.id)">
              <li class="InformationInquiryItemLi" :class="{'is-active':activeValue==item.id}">
                  <span>{{item.label}}</span>
              </li>
<!--              <el-divider direction="vertical" v-if="index!=typeList.length-1"></el-divider>-->
              <div class="split" v-if="index!=typeList.length-1"></div>
          </div>
      </ul>
      <el-row style="height: 25px"></el-row>
      <information-card :data-list="dataList"></information-card>
  </div>
</template>

<script>
    import InformationCard from "./InformationCard";
    // import {informationInquiry} from "../../../utils/staticDict";

    export default {
        name: "InformationInquiry",
        components:{InformationCard},
        props:{
            typeList: {
                type: Array,
                default: () => []
            },
        },
        data(){
            return{
                activeValue:'',
                dataList:[]
            }
        },
        methods:{
            eventBus(id){
                this.activeValue=id
            }
        },
        watch:{
            typeList:{
              handler(){
                this.activeValue = this.typeList.length?this.typeList[0].id:''
                this.dataList = this.typeList.length?this.typeList[0].value:[]
              }
            },
            activeValue:{
                handler(id){
                    this.typeList.forEach(el => {
                        if(el.id == id) {
                            this.dataList = el.value;
                          console.log("this.dataList",el,this.dataList)
                        }
                    })

                    // this.dataList=informationInquiry[value]
                }
            }
        },
        mounted() {
        }
    }
</script>

<style scoped lang="less">
@import "../../../styles/theme";
.InformationInquiry{
    display: flex;
    padding: 0;
    margin: 0;
    border-bottom: 1px solid #dddddd;
  .InformationInquiryItem{
      display: flex;
      margin-bottom: -1px;
      /*border-bottom: 1px solid #dddddd;*/
      .InformationInquiryItemLi{
          list-style: none;
          /*padding: 5px 0 10px;*/
          font-size: 17px;
          text-align: center;
          width: 100%;
          cursor: pointer;
          line-height: 35px;
      }
      .is-active{
          color: @theme-color;
          font-weight: 700;
          border-bottom: 2px solid;
      }
      /deep/ .el-divider--vertical{
          /*background-color:#2C3E50;*/
          /*height: 1.6rem;*/
          /*margin: 10px 8px;*/
          border-left: 1px solid #909399;
          height: 22px;
          margin-top: 7px;
      }
      .split{
          border-left: 1px solid #909399;
          height: 22px;
          margin-top: 7px;
      }
  }
}
</style>
